export default __webpack_public_path__ + "static/media/pop-up1.6f873e99.jpeg";